var React = require('react');

function Team (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5 5.936a2 2 0 110-3.872 4 4 0 000 3.872zM8 7.464A4 4 0 118 .536a4 4 0 110 6.928zM10 2a2 2 0 012 1.983v.033A2 2 0 0110.019 6H9.978A2 2 0 0110 2zM3 9a3 3 0 00-3 3v2h2v-2a1 1 0 011-1h1.172A2.999 2.999 0 004 12v2h2v-2a1 1 0 011-1h6a1 1 0 011 1v2h2v-2a3 3 0 00-3-3H3z","fill":"#919DAF"}));
}

Team.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none"};

module.exports = Team;

Team.default = Team;
